var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"md-3"},[_c('b-row',[_c('b-col',{staticClass:"align-left"},[_c('p',[_c('span',[_vm._v("Histórico de datagramas recibidos")]),_c('span',{staticStyle:{"float":"right","padding-right":"30px"}},[_c('VueToggles',{attrs:{"value":_vm.checked,"height":"30","width":"90","checkedText":_vm.timerCheckText,"uncheckedText":"OFF","checkedBg":"#b4d455","uncheckedBg":"lightgrey"},on:{"click":_vm.toggleTimer}})],1),_c('span',{staticStyle:{"float":"right","padding-right":"20px","font-size":"16px"}},[_vm._v("Auto-refrescar")])]),_c('hr',{staticStyle:{"opacity":"0.1 !important"}})])],1),_c('b-card-text',{staticClass:"userTable"},[_c('div',[_c('vue-good-table',{attrs:{"mode":"remote","totalRows":_vm.totalRecords,"columns":_vm.columns,"rows":_vm.rows,"search-options":{
            //enabled: true,
            //trigger: 'enter',
            skipDiacritics: true,
            //searchFn: mySearchFn,
            placeholder: 'Buscar en la tabla',
            //externalQuery: searchQuery
          },"sort-options":{
            enabled: true,
            initialSortBy: { field: 'fecharegistro', type: 'desc' },
          },"pagination-options":{
            enabled: true,
            //mode: 'records',
            //perPage: 10,
            //dropdownAllowAll: false,
            //setCurrentPage: 2,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: 'Filas por pagina',
            ofLabel: 'de',
            pageLabel: 'pagina', // for 'pages' mode
            allLabel: 'Todas',
          }},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'datagrama')?_c('span',[_c('span',{class:_vm.estiloDatagrama,attrs:{"title":"Ampliar datagrama"},on:{"click":_vm.activeLink}},[_vm._v("\n                "+_vm._s(props.row.datagrama)+"\n              ")])]):_vm._e()]}}])})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }